// use methods as callbacks with react hooks useEffect
// e.g. useEffect(() => (
//        manageClickListener(expandTagsButton, tagListExpanded, setTagListExpanded), [tagListExpanded])
//      ), [expandTagsButton, tagListExpanded, setTagListExpanded]);

export const manageDropdownListener = (ref, toggle, updateToggle) => {
  const handleInteractions = (e) => {
    e.stopPropagation();

    if (
      e.key === 'Escape'
      || e.type === 'closeBFDropdowns'
      || (e.type === 'click' && !ref.current.contains(e.target)) // click outside of dropdown
    ) {
      updateToggle(false);
    }
  };

  if (toggle) {
    window.addEventListener('click', handleInteractions);
    window.addEventListener('keyup', handleInteractions);
    window.addEventListener('closeBFDropdowns', handleInteractions);
  } else {
    window.removeEventListener('click', handleInteractions);
    window.removeEventListener('keyup', handleInteractions);
    window.removeEventListener('closeBFDropdowns', handleInteractions);
  }

  return () => {
    window.removeEventListener('click', handleInteractions);
    window.removeEventListener('keyup', handleInteractions);
    window.removeEventListener('closeBFDropdowns', handleInteractions);
  };
};

export const manageKeydownListener = (toggle, keydownCallback) => {
  if (!keydownCallback) return undefined;

  const handleKeypress = (e) => {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'Enter') {
      e.stopPropagation();
      e.preventDefault();
      keydownCallback(e.key);
    }
  };

  if (toggle) {
    window.addEventListener('keydown', handleKeypress);
  } else {
    window.removeEventListener('keydown', handleKeypress);
  }

  return () => {
    window.removeEventListener('keydown', handleKeypress);
  };
};
